/* eslint-disable */

export const endings = {
  we: {
    single: 'свадьба',
    mult: 'свадьбы',
  },
  fl: {
    single: 'оформление',
    mult: 'оформления',
  },
  or: {
    single: 'мероприятие',
    mult: 'мероприятия',
  },
};

export const types = {
  weddings: 'Свадьбы',
  fl: 'Флористическое оформление',
  fl_wedding: 'Оформление свадьбы цветами',
  fl_reg: 'Оформление выездной регистрации',
  fl_table: 'Оформление сладкого стола',
  fl_photo: 'Оформление зон фотосессии',
  fl_theme: 'Оформление мероприятий',
  fl_stub: 'Стабилизированные цветы',
  org: 'Организация мероприятий',
  org_private: 'Частные',
  org_corp: 'Корпоративные',
  org_child: 'Детские',
};

export const filters = [
  {
    name: 'Все категории',
    tp: '',
    types: [],
  },
  {
    name: 'Свадьбы',
    tp: 'weddings',
    types: [],
  },
  {
    name: 'Флористическое оформление',
    tp: 'fl',
    types: [{
      name: 'Все виды',
      tp: '',
    }, {
      name: 'Оформление свадьбы цветами',
      tp: 'fl_wedding',
      desc: 'Свадьба — не только союз двух любящих сердец, но и праздник для самых близких людей молодоженов. В этот день каждый старается одеться максимально красиво, сказать самые красивые пожелания и, поэтому, для оформления свадебных торжеств команда «Антуриум» всегда советует живые цветы — самые красивые.',
    }, {
      name: 'Оформление выездной регистрации',
      tp: 'fl_reg',
      desc: 'Каждой паре молодоженов хочется, чтобы их день свадьбы стал по-настоящему запоминающимся. И выездная регистрация — наиболее верный путь к этому. Конечно, никто не отменяет факта, что молодожены должны расписаться в стенах ЗАГСа, но какие же сильные эмоции останутся у гостей, жениха и невесты, от регистрации, допустим, на фоне реки под аркой из цветов? У выездной регистрации еще много плюсов: вы можете выбрать концепцию, место, украшения и продумать вместе с командой «Антуриум» другие детали, чтобы именно этот день остался в памяти у всех присутствующих.',
    }, {
      name: 'Оформление сладкого стола',
      tp: 'fl_table',
      desc: 'Ни для кого не секрет, что на свадьбе случаются заминки по времени, что некоторые из гостей не знакомы между собой. Но всё это сможет сыграть на руку, если организован «Сладкий стол». Здесь каждый сможет найти сладость или другое лакомство по вкусу, сделать памятные фотографии, а заодно узнать собравшихся поближе. Традиция десертного стола лишь недавно пришла к нам из Европы, но уже обрела большую популярность. Благодаря “Candy bar”, вы сможете поддержать общую концепцию всего торжества и добавить изысканности.',
    }, {
      name: 'Оформление зон фотосессии',
      tp: 'fl_photo',
      desc: 'Эмоции — лучшее украшение любого торжества. И для того, чтобы сохранить улыбки и радость гостей, стоит заранее подумать над созданием фотозоны. Во-первых, это поможет избежать ненужных деталей или ракурсов на снимках. Во-вторых, вы всегда сможете заранее выбрать тему зоны для фотосессий, единственное ограничение — это воображение.',
    }, {
      name: 'Оформление мероприятий',
      tp: 'fl_theme',
    }, {
      name: 'Стабилизированные цветы',
      tp: 'fl_stub',
    }],
  }, {
    name: 'Организация мероприятий',
    tp: 'org',
    types: [{
      name: 'Все виды',
      tp: '',
    }, {
      name: 'Частные',
      tp: 'org_private',
    }, {
      name: 'Корпоративные',
      tp: 'org_corp',
    }, {
      name: 'Детские',
      tp: 'org_child',
    }],
  },
];



// WEBPACK FOOTER //
// ./src/utils/consts.js